var map = {
	"./IMG-20241228-WA0003.jpg": 921,
	"./IMG-20241228-WA0004.jpg": 5178,
	"./IMG-20241228-WA0007.jpg": 9317,
	"./IMG-20241228-WA0011.jpg": 4392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4964;